module.exports = __webpack_public_path__ + "static/media/word.d3ada4ec.svg";